import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { AmountFormat } from '../../Format/AmountFormat';
import DetailsRow from './DetailsRow';

const PaymentRemarks = ({ paymentRemarks }) => {
  const { t } = useTranslation();
  return (
    <div>
      {paymentRemarks?.map((paymentRemark, index) => {
        return (
          <table style={{ marginBottom: '16px' }} key={index}>
            {paymentRemark.amount && (
              <DetailsRow
                label={t(`onboard.customer.singleView.credit.amount`)}
                value={
                  <AmountFormat
                    isCents={false}
                    amount={paymentRemark.amount.amount}
                    currencyCode={paymentRemark.amount.currency}
                    fractionDigits="0"
                  />
                }
              />
            )}
            {paymentRemark.date && (
              <DetailsRow label={t(`onboard.customer.singleView.credit.date`)} value={paymentRemark.date} />
            )}
            {paymentRemark.creditor && (
              <DetailsRow
                label={t(`onboard.customer.singleView.credit.creditor`)}
                value={paymentRemark.creditor.name}
              />
            )}
            {paymentRemark.description && (
              <DetailsRow
                label={t(`onboard.customer.singleView.credit.description`)}
                value={paymentRemark.description}
              />
            )}
          </table>
        );
      })}
    </div>
  );
};

PaymentRemarks.propTypes = {
  paymentRemarks: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
      }),
      date: PropTypes.string,
      creditor: PropTypes.shape({
        name: PropTypes.string,
      }),
      description: PropTypes.string,
    }),
  ),
};

export default PaymentRemarks;
